export const createSlugUrl = (username, type, title, uuid) => {
  const MAX_SLUG_LENGTH = 60; // Standard SEO practice

  const safeTitle = (title || "post")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .substring(0, MAX_SLUG_LENGTH) // Cap the length
    .replace(/-+$/, ""); // Ensure we don't end on a trailing dash from the crop

  const stringId = String(uuid || "");
  const shortId = stringId.includes("-") ? stringId.split("-")[0] : stringId.substring(0, 8);

  const cleanUsername = String(username || "user").replace("@", "");
  
  return `/posts/@${cleanUsername}/${safeTitle}-${shortId}`;
};